import { render, staticRenderFns } from "./PinSVG.vue?vue&type=template&id=b9ff4d2a&"
import script from "./PinSVG.vue?vue&type=script&lang=js&"
export * from "./PinSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports